import { atom } from "jotai";
import { darkStyledTheme, styledTheme } from "theme/index";

import { STORAGE_KEYS } from "../library/shared";
import { FilterItem, IChatbotMessageHistory, IClient, INotification } from "../library/types";
import { loadFromLocalStorage, saveToLocalStorage } from "../library/utils";

const darkModeLocalStorageAtom = atom(
  // Initialize with value from localStorage or a fallback value
  loadFromLocalStorage(STORAGE_KEYS.darkMode, false) // Can be any default value or object
);

export const darkModeAtom = atom(
  (get) => get(darkModeLocalStorageAtom), // Read atom value
  (get, set, newValue) => {
    set(darkModeLocalStorageAtom, newValue); // Update atom
    saveToLocalStorage(STORAGE_KEYS.darkMode, newValue); // Save new value to localStorage
  }
);

const selectedFullThemeLocalStorageAtom = atom(
  // Initialize with value from localStorage or a fallback value
  loadFromLocalStorage(STORAGE_KEYS.selectedFullTheme, {
    light: styledTheme,
    dark: darkStyledTheme,
  }) // Can be any default value or object
);

export const selectedFullThemeAtom = atom(
  (get) => get(selectedFullThemeLocalStorageAtom), // Read atom value
  (get, set, newValue) => {
    set(selectedFullThemeLocalStorageAtom, newValue); // Update atom
    saveToLocalStorage(STORAGE_KEYS.selectedFullTheme, newValue); // Save new value to localStorage
  }
);

export const panelIsOpenState = atom(false);

export const chatPanelOpenAtom = atom(false);
export const chatIdAtom = atom<any>(null);

export const notificationMessagesAtom = atom<INotification[] | []>([]);

export const selectedClientAtom = atom<IClient | null | undefined>();

export const chatHistoryAtom = atom<IChatbotMessageHistory[]>([{}]);

export const benefitCardImageAtom = atom(false);

export const selectedBenefitCurrencyAtom = atom("");

export const selectedCategoryFilterAtom = atom<FilterItem>({});
export const selectedStatusFilterAtom = atom<FilterItem>({});
